// Provides a rank value for an outline number attached to an entity, for sorting by those outline numbers.
// This can't be just an alpha sort because, say, 3.10 < 3.2 in that case, which is incorrect.
export var entityOutlineNumberRank = function (item) {
  var _a;
  if (!item.outlineNumber) return 0;
  var parts = (_a = item.outlineNumber) === null || _a === void 0 ? void 0 : _a.split('.');
  var rank = parts.reduce(function (acc, val, i) {
    var multiplier = Math.pow(10, (parts.length - 1 - i) * 2);
    return acc + parseInt(val, 10) * multiplier;
  }, 0);
  return rank;
};